import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AboutHero from "./components/AboutHero";
import AboutContent from "./components/AboutContent";
import CTASection from "@/pages/home/components/CTASection";
import ContactSection from "@/pages/home/components/ContactSection";

export default function Hakkimizda() {
  return (
    <main className="bg-[#F8FAFC]">
      <Navbar />
      <AboutHero />
      <AboutContent />
      <CTASection />
      <ContactSection />
      <Footer />
    </main>
  );
}
